import React, { Component } from 'react';
import CoffeeTracker from './components/CoffeeTracker'

class Dashboard extends Component {
  constructor(props) {
    super(props);
    if(this.props.order.items.length === 0)
      window.location.href = '#/dashboard';
  }


  getItems(){
    var order = this.props.order
    return order.items.concat(order.prevItems)
      .map((item, i)=>
        <tr key={i}>
          <td>
            {item.name}
            { order.type === 'coffee' ? (' - ' + item.size) : null }
            { order.prevItems.length ? ' - ' + item.person.name : '' }
          </td>
          {item.time ? <td>{item.time}</td> : null}
          <td>${this.toCurrency(item.price)}</td>
          { order.type === 'coffee' ? null :
            <td>{item.quantity}</td> }
        </tr>
      )
  }

  getSubTotal(){
    var order = this.props.order
    return order.items.concat(order.prevItems)
      .reduce((x, y)=>x+ y.price*y.quantity, 0)
  }

  getSurcharge(){
    var stot = this.getSubTotal();
    if(this.props.order.payment === 'poli')
      return stot * 0.01
    return (stot + 0.3)/(1-0.029) - stot
  }

  getTotal(){
    return this.getSurcharge() + this.getSubTotal();
  }

  getSurchargeName(){
    return this.props.order.payment === 'poli' ?
      'Poli (internet banking)' :
      'Credit / Debit Card';
  }

  toCurrency(num){
    return (Math.ceil(num * 100) / 100).toFixed(2)
  }

  render() {
    if(!this.props.order.items.length)
      return null;
    return (
      <div className="">
        <h1>Order Confirmation</h1>
        { this.props.order.type === 'coffee' ? (
          <p>{this.props.order.customer.name} - {this.props.order.customer.school.name}</p>
        ) : (
          <p>{this.props.order.date.name}{this.props.order.prevItems.length ? '' : ` - ${this.props.order.customer.name}`}</p>
        )}

        { this.props.order.type === 'coffee' ?
          <CoffeeTracker schoolId={this.props.order.customer.school.id}
            orderId={this.props.order.id} /> : null }

        <table className="table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Price</th>
              { this.props.order.type === 'coffee' ? null :
                <th>Quantity</th> }
            </tr>
          </thead>
          <tbody>
            { this.getItems() }
          </tbody>
        </table>

        <div className="text-center">
          <p>{this.getSurchargeName()} Surcharge: ${this.toCurrency(this.getSurcharge())}</p>
          <h2>Order Total ${this.toCurrency(this.getTotal())}</h2>
          <h2>Your order has been placed! Thank you</h2>
          <h3>
            {
              this.props.order.customer.school.pickup.replace(
                '{day}',
                this.props.order.date.name
              )
            }
          </h3>
          <p>
            If you have any questions, please
            contact <a href="mailto:billie@myschoollunch.co.nz">billie@myschoollunch.co.nz</a>
          </p>
        </div>
      </div>
    );
  }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/pages/Done.js